import { FC } from 'react';
import intl from 'react-intl-universal';
import MoreActionsPopup, {
  OptionProps,
} from 'Organisms/TableHeaderActionButtons/MoreActionsPopup';
import ExportIcon from 'assets/icons/export.svg';

interface ImportExportActionsProps {
  onExport: (callback: () => void) => void;
  exportEnabled?: Boolean;
}

const ImportExportActions: FC<ImportExportActionsProps> = ({
  exportEnabled = false,
  onExport,
}) => {
  const tableActionsList: Partial<OptionProps>[] = [
    {
      label: intl.get('TASKS.TABLE.EXPORT'),
      selectOption: onExport,
      disabled: !exportEnabled,
      tooltip: {
        text: !exportEnabled ? intl.get('TASKS.TABLE.EXPORT_TOOLTIP') : '',
      },
      iconSrc: ExportIcon,
    },
  ];

  return <MoreActionsPopup options={tableActionsList} />;
};

export default ImportExportActions;
